import { Text, Tr, Td } from '@chakra-ui/react'
import { ExposureData } from '../../../../../types/FirestoreUser'
import ExposureRow from './ExposureRow'

interface ConditionSectionProps {
  title: string
  conditions: { name: string }[]
  uid: string
  exposureHistory: ExposureData[]
  setExposureHistory: (data: ExposureData[]) => void
  userAge: number | undefined
}

const ConditionSection = ({
  title,
  conditions,
  uid,
  exposureHistory,
  setExposureHistory,
  userAge,
}: ConditionSectionProps) => {
  return (
    <>
      <Tr>
        <Td colSpan={6}>
          <Text fontWeight="bold">{title}</Text>
        </Td>
      </Tr>
      {conditions
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((condition) => (
          <ExposureRow
            key={condition.name}
            condition={condition.name}
            uid={uid}
            exposureHistory={exposureHistory}
            setExposureHistory={setExposureHistory}
            userAge={userAge}
          />
        ))}
    </>
  )
}

export default ConditionSection